/**
 * 公共组件所需的接口api文件
 */
import localforage from 'localforage';
import request from '@/utils/http';
import { getSession, setSession, getLocal, setLocal } from '@/utils/storage';
import { DateDiff } from './utils';
import dictQueue from './DictQueue';
import store from '@/store';
const LINKSYM = '#';

/**
 * 省市区相关接口
 */
// 初始化indexedDb数据表
const addressDb = localforage.createInstance({
    storeName: 'address'
});
// 省市四级联动
const millisecond = 1000;
const sixty = 60;
const timeOfDay = 24;
export const getAreaApi = async (params, difference = millisecond * sixty * sixty * timeOfDay, areaUrl) => {
    const currentTimestamp = new Date().getTime();
    const areaList = await addressDb.getItem(String(params.ebplParentPmCode));
    if (areaList && areaList.time && DateDiff(currentTimestamp, areaList.time, difference)) {
        return {
            code: '0',
            data: areaList.data
        };
    } else {
        params.ebplIsAble = 'ENABLE';
        return request({
            url: areaUrl || '/api-mdm/searchEbPlace',
            method: 'get',
            params: params
        }).then(res => {
            if (res && res.code === '0') {
                addressDb.setItem(String(params.ebplParentPmCode), {
                    time: new Date().getTime(),
                    data: res.data
                });
            }
            return res;
        });
    }
};

/**
 * 列配置相关接口
 */
// 列配置
export const columnsConfigApi = {
    save(params) {
        return request({
            url: '/api-auth/userIndividualConfigs/saveOrUpdate',
            method: 'post',
            data: params
        });
    },
    get(params) {
        return request({
            url: '/api-auth/userIndividualConfigs/param',
            method: 'post',
            data: params
        });
    }
};

/**
 * 列配置和自定义搜索条件配置相关接口
 */
export const getList = {
    post(url, params) {
        const key = `${params.id}-${params.subjectType}-${params.moduleCode}`;
        Reflect.deleteProperty(params, 'id');
        setLocal(key, params.configName);
        return request({
            url: url + '/userIndividualConfigs/saveOrUpdate',
            method: 'post',
            data: params
        });
    },
    get(url, params) {
        const key = `${params.id}-${params.subjectType}-${params.moduleCode}`;
        Reflect.deleteProperty(params, 'id');
        if (getLocal(key)) {
            return Promise.resolve({
                code: '0',
                data: {
                    configName: getLocal(key)
                }
            });
        } else {
            return request({
                url: url + '/userIndividualConfigs/param',
                method: 'post',
                data: params
            }).then(res => {
                if (res.code === '0') {
                    setLocal(key, res.data.configName || '');
                }
                return res;
            });
        }
    }
};
export const fieldConfig = {
    set: (params) => {
        return getList.post('/api-auth', params);
    },
    get: (params) => {
        return getList.get('/api-auth', params);
    }
};

/**
 *  数据字典相关接口
 */
function getDictCache(keysStr) {
    if (!keysStr) {
        return {
            result: {},
            passKeys: ''
        };
    }
    const currentTenant = store.state.currentTenant;
    const tenantCode = currentTenant ? currentTenant.tenantCode : null;
    const locale = store.getters.locale || 'zh-CN';
    const keys = keysStr.split(',');
    const result = {};
    const passKeys = [];
    keys.forEach(key => {
        const sessionKey = [locale, tenantCode, key].join(LINKSYM);
        const val = getSession(sessionKey);
        if (val) {
            result[key] = val;
        } else {
            passKeys.push(key);
        }
    });
    return {
        result,
        passKeys: passKeys.join(',')
    };
}
function setDictCache(map) {
    const currentTenant = store.state.currentTenant;
    const tenantCode = currentTenant ? currentTenant.tenantCode : null;
    const locale = store.getters.locale || 'zh-CN';
    Object.keys(map).forEach(key => {
        const sessionKey = [locale, tenantCode, key].join(LINKSYM);
        setSession(sessionKey, map[key]);
    });
}
// 字典值
export const dict = (popPrefix, params) => {
    const type = Object.prototype.toString.call(params);
    let dictCodes = null;
    if (type === '[object String]') {
        dictCodes = params;
    } else {
        dictCodes = params.dictCodes;
    }
    const data = getDictCache(dictCodes);
    if (data.passKeys === '') {
        return new Promise(resolve => {
            resolve({
                code: '0',
                data: data.result
            });
        });
    } else {
        return request({
            url: popPrefix,
            method: 'get',
            params: {
                // 不区分租户
                // tenantCode: params.tenantCode,
                dictCodes: data.passKeys
            }
        }).then(res => {
            setDictCache(res.data);
            res.data = { ...data.result, ...res.data };
            return res;
        });
    }
};
// export const dictWithUrl = (params) => {
//     return dict('/api-mdm/dictionaryDetail/dict', params);
// };
// 排队
// const dictQueue = new DictQueue();
/**
 * @desc 这个方法已经内含缓存判断逻辑，有缓存则取缓存，没有则从接口取，无需调用其他方法获取字典
 * @param params 字典code多个用逗号隔开
 * @param url 默认/api-mdm/dictionaryDetail/dict
 * 示例 ：dictWithUrl('SYS_IWMS_GW_SEND_ERROR_MESSAGE,SYS_IWMS_GW_MOINTOR_STATUS');
 */
export const dictWithUrl = (params, url = '/api-mdm/dictionaryDetail/dict') => {
    dictQueue.setFetchFn(params => dict(url, params));
    const dictCodes = Object.prototype.toString.call(params) === '[object String]' ? params : params.dictCodes;
    return dictQueue.queueUp(dictCodes, url);
};
export const getUnreadMessage = () => {
    return request({
        url: '/api-lcs/ztc/getUnreadMessage',
        method: 'get'
    }).then(res => res);
};
/* 获取annto经营中心直通车虚拟token */
export const acquireTemporaryToken = (params) => {
    return request({
        url: `/api-auth/acquireTemporaryToken`,
        method: 'get',
        params: params
    }).then(res => res);
};
/**
 *  保存常用菜单接口
 */
export const saveUserHitMenuData = (data) => {
    return request({
        url: `/api-auth/saveUserHitMenuData`,
        method: 'post',
        data
    }).then(res => res);
};
